<template>
  <!--  人员检索 -->
  <el-container class="personSearch">
    <el-tabs v-model="activeName" class="aa" @tab-click="handleClick">
      <el-tab-pane label="人脸搜索" name="first">
        <face-searche
          v-if="activeName == 'first'"
          ref="facesearcheRef"
        ></face-searche>
      </el-tab-pane>
      <el-tab-pane label="人体搜索" name="second">
        <body-searche
          v-if="activeName == 'second'"
          ref="bodysearcheRef"
          :dictList="dictObj"
        ></body-searche>
      </el-tab-pane>
      <el-tab-pane label="背影识人" name="third">
        <back-searche
          v-if="activeName == 'third'"
          @rnImg="rnImg"
          :dictList="dictObj"
        ></back-searche>
      </el-tab-pane>
      <el-tab-pane label="特征搜索" name="fourth">
        <feature-searche
          v-if="activeName == 'fourth'"
          @rnImgs="rnImgs"
          :dictList="dictObj"
        ></feature-searche>
      </el-tab-pane>
    </el-tabs>
    <!-- <div class="Hbadge">
      <el-badge @click="formVisible = true" :value="12" class="item">
        <i :class="['iconfont', 'icon-zhuangbei']" style="font-size: 24px"></i>
      </el-badge>
    </div> -->
  </el-container>
  <el-dialog v-model="formVisible" title="轨迹列表" width="50%">
    <div class="dialogClass">
      <el-card class="hCard" :body-style="{ padding: '10px' }">
        <!-- <el-image
          :src="itemRow.imagePartUrl"
          :preview-src-list="srcList"
          :initial-index="4"
          fit="cover"
        >
        </el-image> -->
      </el-card>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button type="primary" @click="emitCheckList">生成轨迹</h-button>
        <h-button type="primary" @click="emitCheckList">全部清除</h-button>
        <h-button type="primary" @click="formVisible = false">取消</h-button>
        <!-- <h-button @click=" = false">取消</h-button> -->
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, toRefs, provide, readonly, ref } from "vue";
import faceSearche from "./components/faceSearche.vue";
import backSearche from "./components/backSearche.vue";
import bodySearche from "./components/bodySearche.vue";
import featureSearche from "./components/featureSearche.vue";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "personSearch",
  // eslint-disable-next-line vue/no-unused-components
  components: { faceSearche, backSearche, bodySearche, featureSearche },
  props: {},
  setup(props) {
    const facesearcheRef = ref(null);
    const bodysearcheRef = ref(null);

    const state = reactive({
      activeName: "first",
      formVisible: false,
      dictObj: {},
    });
    const refData = toRefs(state);
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    const rnImg = (val, is) => {
      if (is === "dataListrt") {
        state.activeName = "first";
        facesearcheRef.value.imageListUrl(val);
      } else {
        state.activeName = "second";
        bodysearcheRef.value.imageListUrl(val);
      }
    };
    const rnImgs = (val, is) => {
      state.activeName = "second";
      bodysearcheRef.value.imageListUrl(val);
    };
    // 获取数据字典
    const queryMenuType = async () => {
      const resGrain = await getDict("zghz_rt_coat_grain");
      const coat_style = await getDict("coat_style");
      const jacket_style = await getDict("zghz_rt_jacket_style");
      const jacket_length = await getDict("zghz_rt_jacket_length");
      const trousers_style = await getDict("zghz_rt_trousers_style");
      const trousers_length = await getDict("trousers_length");
      const color = await getDict("color");

      state.dictObj = {
        coatGrain: resGrain.dict,
        coatLength: jacket_length.dict,
        coatStyle: coat_style.dict,
        trousersColor: color.dict,
        trousersStyle: trousers_style.dict,
        trousersLength: trousers_length.dict,
      };
      console.log(state.dictObj);
    };
    queryMenuType();
    provide("activeName", readonly(refData.activeName));
    return {
      ...refData,
      handleClick,
      rnImg,
      facesearcheRef,
      bodysearcheRef,
      rnImgs,
    };
  },
});
</script>
<style lang="scss" scoped>
.personSearch {
  height: 100%;
  .el-tabs {
    width: 100%;
  }
  // .Hbadge {
  //   position: relative;
  //   top: 7px;
  //   right: 30px;
  // }
}
.dialogClass {
  height: 50vh;
}
</style>
